import { $, $$, requireElement } from '../../lib/dom';
import { nextRovingItem } from '../../lib/roving-focus';

const HOVER_CLOSE_DELAY_MS = 140;

function setOpen(item: HTMLElement, open: boolean): void {
  requireElement('.dd-btn', item).setAttribute('aria-expanded', String(open));
  requireElement('.dd', item).classList.toggle('open', open);
}

export function closeAllDropdowns(except?: HTMLElement): void {
  $$('.has-dd').forEach((item) => {
    if (item !== except) setOpen(item, false);
  });
}

/** Solutions / Company menus: hover on pointer devices, click and full keyboard support everywhere. */
export function initDropdowns(): void {
  const canHover = window.matchMedia('(hover: hover)');
  $$('.has-dd').forEach((item) => {
    const button = requireElement('.dd-btn', item, HTMLButtonElement);
    const menu = requireElement('.dd', item);
    let closeTimer: number | undefined;

    const open = (focusFirst = false): void => {
      clearTimeout(closeTimer);
      closeAllDropdowns(item);
      setOpen(item, true);
      if (focusFirst) $('a', menu)?.focus();
    };
    const close = (focusButton = false): void => {
      setOpen(item, false);
      if (focusButton) button.focus();
    };
    const isOpen = (): boolean => button.getAttribute('aria-expanded') === 'true';

    item.addEventListener('mouseenter', () => {
      if (canHover.matches) open();
    });
    item.addEventListener('mouseleave', () => {
      if (canHover.matches)
        closeTimer = window.setTimeout(() => {
          close();
        }, HOVER_CLOSE_DELAY_MS);
    });
    button.addEventListener('click', () => {
      if (isOpen()) close();
      else open();
    });
    button.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown' || ((event.key === 'Enter' || event.key === ' ') && !isOpen())) {
        event.preventDefault();
        open(true);
      }
      if (event.key === 'Escape') close(true);
    });
    menu.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        close(true);
        return;
      }
      const links = $$('a', menu);
      const next = nextRovingItem(links, document.activeElement, event.key, 'vertical');
      if (next) {
        event.preventDefault();
        next.focus();
      }
    });
    item.addEventListener('focusout', (event) => {
      if (!(event.relatedTarget instanceof Node && item.contains(event.relatedTarget))) close();
    });
    menu.addEventListener('click', (event) => {
      if (event.target instanceof Element && event.target.closest('a')) close();
    });
  });
}
